import api from "../configs/api";

const { createContext, useState, useEffect, useContext } = require("react");

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [ads, setAds] = useState(null);
  const [adsLoading, setAdsLoading] = useState(true);

  const fetchAdvertisements = async () => {
    try {
      setAdsLoading(true);
      const { data } = await api.get("/advertisements");
      setAds(data);
    } catch (err) {
      console.error("Failed to fetch ads:", err);
    } finally {
      setAdsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  return (
    <AppContext.Provider
      value={{ ads, adsLoading, refreshAdvertisements: fetchAdvertisements }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
